"use strict";

exports.__esModule = true;
exports.default = void 0;

/* istanbul ignore file */
class RouteWithPageDecorator {
  [constructor]() {
    this.page = null;
  }
  /**
   * @return {string}
   */


  getPage() {
    return this.page;
  }
  /**
   * @param {string} page
   */


  setPage(page) {
    this.page = page;
    return this;
  }

}

exports.default = RouteWithPageDecorator;